// Powłoka po zalogowaniu - kontener: dane i decyzje APP, wygląd z pakietu (uklad/Powloka.tsx). Menu zależne od roli
// i sprzętu (Przepisy/Plany przy linii z przepisami, Energia przy liczniku, Osiągnięcia przy linii z osiągnięciami,
// Serwis - serwisant i admin), w pasku: wybór pulpitu, szukajka (WYGLAD.md #1), stan „N z M online” (#3, obecność
// z bramy - jedno źródło: worker), dzwonek z nieprzeczytanymi (#2), menu konta z „Wyświetlanie” i Wyloguj (#4).
// Pasek braku sieci (#5), tost (#6), odświeżanie przeciągnięciem i instalacja PWA (funkcje starej APP).
import { Suspense, useEffect, useRef, useState, useSyncExternalStore } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";
import { t, useJezyk } from "./i18n/t";
import { useSesja } from "./sesja";
import { wyloguj } from "./api/konto";
import { naOtwartePowiadomienie, odswiezNoweAlarmy, useNoweAlarmy } from "./api/powiadomienia";
import { polaczPonownie, uruchom, zatrzymaj } from "./brama/polaczenie";
import { odczyt } from "./brama/magazyn";
import { godzinaLubData, inicjaly } from "./uklad/format";
import { Przycisk } from "./uklad/Przyciski";
import { naZdarzenie } from "./brama/zdarzenia";
import { usePolaczenie, useSklad, useStatusy } from "./brama/uzyj";
import { useSerwis, wczytajSerwis } from "./api/serwis";
import { wczytajZaproszenia } from "./api/udostepnienia";
import { wczytajOczekujace } from "./api/oczekujace";
import { wczytajWnioski } from "./api/przypisanie";
import { SKLEP } from "./api/zaplecze";
import { zatrzymajZapas, zrobZapas } from "./api/zapas";
import { useBaneryserwisu } from "./ekrany/serwis/Baner";
import { useBaneryAktualizacji } from "./uklad/Aktualizacja";
import { useWykrywanieUrzadzen } from "./uklad/wykrywanie";
import { useBaneryZaproszen } from "./ekrany/udostepnianie/Baner";
import { useBaneryOczekujacych } from "./ekrany/urzadzenia/Baner";
import { WynikiSzukania } from "./ekrany/Szukajka";
import { jestOnline } from "./ekrany/urzadzenia/obecnosc";
import { useZLicznikiem } from "./ekrany/energia/dostep";
import { useZOsiagnieciami } from "./ekrany/osiagniecia/dostep";
import {
  IkonaAlarmy, IkonaAsystent, IkonaEnergia, IkonaInstrukcje, IkonaMonitor, IkonaOsiagniecia, IkonaPlany, IkonaPrzepisy, IkonaPulpit,
  IkonaSerwis, IkonaStatystyki, IkonaUdostepnij, IkonaUrzadzenia, IkonaUsterka, IkonaUstawienia, IkonaWyloguj,
} from "./uklad/ikony";
import { Odswiezanie } from "./uklad/Odswiezanie";
import { Powloka, type PozycjaNawigacji, type SekcjaNawigacji } from "./uklad/Powloka";
import { PrzyciskInstalacji } from "./uklad/PrzyciskInstalacji";
import { BrakSieci, Ladowanie, Tost } from "./uklad/Stany";
import { useTost } from "./uklad/tost";
import { OknoWyswietlania } from "./uklad/Wyswietlanie";

/** Internet w telefonie (zdarzenia online/offline przeglądarki). */
function useInternet(): boolean {
  return useSyncExternalStore((f) => {
    addEventListener("online", f);
    addEventListener("offline", f);
    return () => { removeEventListener("online", f); removeEventListener("offline", f); };
  }, () => navigator.onLine);
}

export function PowlokaAplikacji() {
  const { sesja, wylogowano } = useSesja();
  useJezyk(); // dociągnięte tłumaczenia - powłoka i bieżący ekran rysują się od nowa
  const { pathname } = useLocation();
  const [wiecej, ustawWiecej] = useState(false);
  const [wyswietlanie, ustawWyswietlanie] = useState(false);
  const [szukaj, ustawSzukaj] = useState("");
  const serwis = useSerwis();
  const energia = useZLicznikiem();
  const osiagniecia = useZOsiagnieciami();
  const noweAlarmy = useNoweAlarmy();
  const sklad = useSklad();
  const statusy = useStatusy();
  const polaczenie = usePolaczenie();
  const internet = useInternet();
  const tost = useTost();
  useWykrywanieUrzadzen(); // aplikacja na Androidzie: sterownik w oknie parowania obok telefonu → powiadomienie
  // Aplikacja ze sklepu: dotknięte powiadomienie pushu otwiera jego ekran (sw.js robi to w przeglądarce).
  const idz = useNavigate();
  const idzRef = useRef(idz);
  useEffect(() => { idzRef.current = idz; });
  useEffect(() => naOtwartePowiadomienie((sciezka) => void idzRef.current(sciezka)), []);
  const banery = [...useBaneryAktualizacji(), ...useBaneryserwisu(), ...useBaneryZaproszen(), ...useBaneryOczekujacych()];

  // Strumień bramy i dane konta - tylko przy zalogowanym, od nowa przy każdym koncie (numer konta). Wcześniej efekt
  // chodził też po wylogowaniu i przy każdej zmianie sesji: strumień bez sesji i jego spóźniona odmowa czyściły magazyn
  // już po zalogowaniu na drugie konto - „brak urządzeń” do F5 (właściciel 24.10).
  const idKonta = sesja.stan === "jest" ? sesja.konto.id : null;
  const wylogowanoRef = useRef(wylogowano);
  useEffect(() => { wylogowanoRef.current = wylogowano; });
  useEffect(() => {
    if (idKonta == null) return;
    uruchom((wygasla) => wylogowanoRef.current(wygasla));
    void wczytajZaproszenia();
    void wczytajSerwis();
    void wczytajOczekujace();
    void wczytajWnioski();
    void odswiezNoweAlarmy();
    zrobZapas(); // aplikacja ze sklepu: dane do pracy bez internetu (api/zapas.ts)
    const odpnij = naZdarzenie("alarm.changed", () => void odswiezNoweAlarmy());
    return () => { odpnij(); zatrzymaj(); zatrzymajZapas(); };
  }, [idKonta]);

  if (sesja.stan !== "jest") return null;
  const k = sesja.konto;
  const wylogujSie = async () => {
    await wyloguj().catch(() => undefined);
    wylogowano();
  };
  // „Pulpit” = `/` i pulpity własne `/pulpit/…`; pozostałe - swoja ścieżka i podstrony (pulpit sztuki w „Urządzeniach”).
  const aktywna = (s: string) => (s === "/" ? pathname === "/" || pathname.startsWith("/pulpit/")
    : pathname === s || pathname.startsWith(s + "/"));
  const poz = (id: string, etykieta: string, sciezka: string, ikona: PozycjaNawigacji["ikona"], extra?: Partial<PozycjaNawigacji>): PozycjaNawigacji =>
    ({ id, etykieta, do: sciezka, ikona, aktywna: aktywna(sciezka), ...extra });
  const nawigacja: SekcjaNawigacji[] = [
    { id: "codzien", tytul: t("Na co dzień"), pozycje: [
      poz("pulpit", t("Pulpit"), "/", IkonaPulpit),
      poz("urzadzenia", t("Urządzenia"), "/urzadzenia", IkonaUrzadzenia),
      poz("udostepnianie", t("Udostępnianie"), "/udostepnianie", IkonaUdostepnij),
      poz("statystyki", t("Statystyki"), "/statystyki", IkonaStatystyki),
      poz("alarmy", t("Alarmy"), "/alarmy", IkonaAlarmy, { licznik: noweAlarmy }),
    ] },
    { id: "wiedza", tytul: t("Gotowanie i wiedza"), pozycje: [
      poz("asystent", t("Asystent"), "/asystent", IkonaAsystent),
      poz("przepisy", t("Przepisy"), "/przepisy", IkonaPrzepisy),
      poz("plany", t("Plany"), "/plany", IkonaPlany),
    ] },
    ...(energia || osiagniecia ? [{ id: "podsumowania", tytul: t("Podsumowania"), pozycje: [
      ...(energia ? [poz("energia", t("Energia"), "/energia", IkonaEnergia)] : []),
      ...(osiagniecia ? [poz("osiagniecia", t("Osiągnięcia"), "/osiagniecia", IkonaOsiagniecia)] : []),
    ] }] : []),
    { id: "pomoc", tytul: t("Pomoc"), pozycje: [
      ...(serwis && (serwis.serwisant || serwis.admin) ? [poz("serwis", t("Serwis"), "/serwis", IkonaSerwis)] : []),
      poz("usterka", t("Zgłoś usterkę"), "/serwis-sprzetu", IkonaUsterka),
      poz("instrukcje", t("Instrukcje"), "/instrukcje", IkonaInstrukcje),
    ] },
  ];
  const online = sklad.filter((d) => jestOnline(statusy[d.sn])).length;
  const stan = sklad.length === 0 || polaczenie !== "jest" ? undefined : {
    tekst: t("{n} z {z} online", { n: online, z: sklad.length }), do: "/urzadzenia",
    rodzaj: online === sklad.length ? "ok" as const : online > 0 ? "uwaga" as const : "wylaczona" as const,
  };
  const nazwa = k.nazwa.trim() || k.login || k.email;
  // Pasek bez połączenia z godziną ostatnich danych i „Spróbuj” (POROWNANIE.md 26.3).
  const ostatnie = odczyt.ostatnieDane();
  const zDanymi = ostatnie ? " " + t("Pokazujemy ostatnie dane z {czas}.", { czas: godzinaLubData(ostatnie) }) : "";
  const brakSieci = !internet ? t("Brak internetu w telefonie.") + zDanymi + " " + t("Sprawdź WiFi albo dane komórkowe.")
    : polaczenie === "przerwa" ? t("Brak połączenia z serwerem.") + zDanymi : null;

  return (
    <Powloka
      nawigacja={nawigacja}
      dolnyPasek={["pulpit", "urzadzenia", "statystyki", "alarmy"]}
      uzytkownik={{ imie: nazwa.split(/\s+/)[0] ?? nazwa, pelneImie: nazwa, email: k.email, inicjaly: inicjaly(k.nazwa, k.email) }}
      pulpit="/"
      alarmy={{ do: "/alarmy", liczba: noweAlarmy }}
      stanUrzadzen={stan}
      szukaj={{ tekst: szukaj, onZmien: ustawSzukaj, podpowiedz: t("Szukaj urządzeń, przepisów, instrukcji…"),
        wyniki: <WynikiSzukania q={szukaj} onWybierz={() => ustawSzukaj("")} /> }}
      menuKonta={[
        { id: "ustawienia", etykieta: t("Ustawienia konta"), ikona: IkonaUstawienia, do: "/ustawienia" },
        { id: "wyswietlanie", etykieta: t("Wyświetlanie"), ikona: IkonaMonitor, onWybierz: () => ustawWyswietlanie(true) },
        { id: "wyloguj", etykieta: t("Wyloguj"), ikona: IkonaWyloguj, onWybierz: () => void wylogujSie() },
      ]}
      menuWiecejOtwarte={wiecej}
      onMenuWiecej={ustawWiecej}
      tytulWiecej={t("Wszystko w aplikacji")}
      stopkaMenu={(m) => <PrzyciskInstalacji miejsce={m} onOtwarte={() => ustawWiecej(false)} />}
      ustawienia={{ do: "/ustawienia", aktywne: aktywna("/ustawienia") }}
      prawne={{ polityka: SKLEP.polityka, regulamin: SKLEP.regulamin }}
      banery={banery}
      nadTrescia={<>
        <Odswiezanie />
        {brakSieci && <BrakSieci tekst={brakSieci} akcja={<Przycisk wariant="jasny" rozmiar="maly" onClick={polaczPonownie}>{t("Spróbuj")}</Przycisk>} />}
      </>}
      tost={tost && <Tost key={tost.id} tekst={tost.tekst} akcja={tost.akcja} />}
    >
      <Suspense fallback={<Ladowanie />}>
        <Outlet />
      </Suspense>
      <OknoWyswietlania otwarte={wyswietlanie} onZmianaOtwarcia={ustawWyswietlanie} />
    </Powloka>
  );
}
